import React from 'react';
import { ButtonProps } from './Types.ts';

const SecondaryButton = ({ visible, disabled, text, onClick }: ButtonProps) => {
  return (
    <>
      {visible && (
        <button className="btn thule-btn-secondary w-100" onClick={onClick} disabled={disabled}>
          {text}
        </button>
      )}
    </>
  );
};

export default SecondaryButton;
